// extracted by mini-css-extract-plugin
var _1 = "FileUploadPlaceholder-moduleFileUploadPlaceholder__LRagJ";
var _2 = "FileUploadPlaceholder-moduledisabled__ppcWt";
var _3 = "FileUploadPlaceholder-moduleerror__cjPMY";
var _4 = "FileUploadPlaceholder-moduleicon__Jp4Xh IconNG-moduleiconContainer__SxWZ0";
var _5 = "FileUploadPlaceholder-moduletext__nKYqT";
export { _1 as "FileUploadPlaceholder", _2 as "disabled", _3 as "error", _4 as "icon", _5 as "text" }
